import { makeStyles } from '@mui/styles';

export const useStatusCountGridStyles = makeStyles((theme) => ({
  largeCard: {
    [theme.breakpoints.up(1135)]: {
      maxWidth: '25%'
    }
  }
}));
